import React, { useCallback, useState } from 'react';
import { Alert, Box, Button, CircularProgress, IconButton, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PdfBackArrow from '../../icons/PdfBackArrow';
import useReportData from '../../reports/useReportData';
import ReportContent, { useStyles } from './ReportContent';
import { reportView } from './reportView';

export { default as ReportContent } from './ReportContent';

export default function CaseSummaryPdfPage() {
  const { id } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();
  const { loading, error, report } = useReportData(id, search);
  const reportKey = `${id}:${search}:${report?.manifest?.generated_at}`;
  const [ready, setReady] = useState({ key: null, value: false });
  const handleReady = useCallback(value => setReady({ key: reportKey, value }), [reportKey]);
  const clientName = report ? reportView(report).clientName : '';
  return <div className="pdfViewerContainer">
    <Box component="header" className={classes.header}>
      <Box display="flex" alignItems="center" gap="24px">
        <IconButton aria-label="Back to case" onClick={() => navigate(`/case/${id}?tab=overview`)}><PdfBackArrow /></IconButton>
        <Typography variant="body1" fontSize="14px" fontWeight="500">SummaryReport_{clientName}</Typography>
      </Box>
      <Button variant="contained" disabled={!report || loading || !!error || ready.key !== reportKey || !ready.value}
        onClick={() => window.print()}>Generate PDF</Button>
    </Box>
    {loading && <Stack alignItems="center" spacing={2} sx={{ pt: '100px' }}><CircularProgress /><Typography>Preparing report…</Typography></Stack>}
    {error && <Alert severity="error" sx={{ mt: '90px', mx: 4 }}>{error} No report has been generated.</Alert>}
    {report && !loading && !error && <ReportContent key={reportKey} report={report} onReady={handleReady} />}
  </div>;
}
